// dependencies
import React from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components
import Avatar from "Components/Avatar";
import TextInput from "Components/Inputs/Text";
import ReportSnapshot from "./components/ReportSnapshot";
import Paginator from "Components/Paginator";

// actions
import { init, searchSnapshots, updateInput, changePage } from "./actions";

// selectors
import {
	getReviewID,
	getReviewName,
	getReportID,
	getReportFormName,
	getAuthorName,
	getAuthorID,
	getSnapshots,
	getSubject,
	getTotalCount,
	getCurrentPage,
} from "./selectors";
import { getIsRequesting } from "Selectors/app";

// config
import config from "./config";

// styles
import css from "./ViewReportSnapshots.styl";

class ViewReportSnapshots extends React.PureComponent {
	static propTypes = {
		init: PropTypes.func.isRequired,
		snapshots: PropTypes.instanceOf(List).isRequired,
		changePage: PropTypes.func.isRequired,
		isRequesting: PropTypes.bool.isRequired,
	};

	componentDidMount = () => {
		this.props.init();
	};

	changePage = (page) => {
		this.props.changePage(page);
	};

	render = () => {
		const {
			authorID,
			authorName,
			reviewName,
			reportFormName,
			snapshots,
			subject,
			totalCount,
			currentPage,
			isRequesting,
		} = this.props;

		const { pageSize } = config;

		const pageCount = Math.ceil(totalCount / pageSize);

		return (
			<div className={css.main}>
				<div className={css.container}>
					<div className={css.reportInformation}>
						<div>
							<div className={css.userContainer}>
								<div className={css.avatarContainer}>
									<Avatar className={css.avatar} userID={authorID} />
								</div>
								<div className={css.userName}>{authorName}</div>
							</div>

							<div>
								<div className={css.detailContainer}>
									<div className={css.detailLabel}>Review</div>
									<div className={css.detailValue}>{reviewName}</div>
								</div>

								<div className={css.detailContainer}>
									<div className={css.detailLabel}>Report Form</div>
									<div className={css.detailValue}>{reportFormName}</div>
								</div>

								<div className={css.detailContainer}>
									<div className={css.detailLabel}>Subject</div>
									<div className={css.detailValue}>{subject}</div>
								</div>

								<div className={css.detailContainer}>
									<div className={css.detailLabel}>Total Snapshots</div>
									<div className={css.detailValue}>{totalCount}</div>
								</div>
							</div>
						</div>
					</div>

					<div className={css.reviewReports}>
						<div>
							{snapshots.map((snapshot) => (
								<ReportSnapshot key={snapshot.get("id")} className={css.snapshot} snapshot={snapshot} />
							))}
						</div>
					</div>

					<div className={css.paginatorWrapper}>
						<Paginator
							onClick={this.changePage}
							pageCount={pageCount}
							currentPage={currentPage}
							isRequesting={isRequesting}
						/>
					</div>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	snapshots: getSnapshots(state),
	reviewID: getReviewID(state),
	reviewName: getReviewName(state),
	reportID: getReportID(state),
	reportFormName: getReportFormName(state),
	authorName: getAuthorName(state),
	authorID: getAuthorID(state),
	subject: getSubject(state),
	totalCount: getTotalCount(state),
	currentPage: getCurrentPage(state),
	isRequesting: getIsRequesting(state, "REVIEWREPORTSNAPSHOTS:GET"),
});

const mapDispatchToProps = (dispatch) => ({
	init: () => dispatch(init()),
	changePage: (page) => dispatch(changePage(page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewReportSnapshots);
